(function () {
  'use strict';

  var root = document.querySelector('[data-ldc-root]');
  if (!root || root.dataset.ldcReady === 'true') return;
  root.dataset.ldcReady = 'true';

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ldc-card]'));
  var editorial = root.querySelector('[data-ldc-editorial]');
  var grid = root.querySelector('[data-ldc-grid]');
  var count = root.querySelector('[data-ldc-count]');
  var empty = root.querySelector('[data-ldc-empty]');
  var shapeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ldc-shape]'));
  var styleButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ldc-style]'));
  var styleReset = root.querySelector('[data-ldc-style-reset]');
  var guidance = root.querySelector('[data-ldc-guidance]');
  var filterTrigger = root.querySelector('[data-ldc-filter-trigger]');
  var filterPanel = root.querySelector('[data-ldc-filter-panel]');
  var sort = root.querySelector('[data-ldc-sort]');
  var activeShape = 'all';
  var activeStyle = '';
  var activeSort = 'manual';

  function isDesktopGrid() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function placeEditorial() {
    if (!editorial || !grid || activeSort !== 'manual') return;
    var targetOrder = isDesktopGrid() ? '12' : '6';
    var target = cards.find(function (card) {
      return card.dataset.manualOrder === targetOrder;
    });
    if (target) target.insertAdjacentElement('afterend', editorial);
  }

  function alignIncompleteRows() {
    cards.forEach(function (card) {
      card.style.removeProperty('grid-column');
    });
    if (!grid || !isDesktopGrid()) return;

    var segments = [[]];
    Array.prototype.slice.call(grid.children).forEach(function (item) {
      if (item === editorial && !editorial.hidden) {
        segments.push([]);
      } else if (item.matches && item.matches('[data-ldc-card]') && !item.hidden) {
        segments[segments.length - 1].push(item);
      }
    });

    segments.forEach(function (segment) {
      var remainder = segment.length % 4;
      if (!remainder) return;
      var start = { 1: 4, 2: 3, 3: 2 }[remainder];
      segment.slice(-remainder).forEach(function (card, index) {
        card.style.gridColumn = String(start + (index * 2)) + ' / span 2';
      });
    });
  }

  function applyRequestedStyle() {
    var requested = new URLSearchParams(window.location.search).get('style');
    if (!requested) return;
    var matchingButton = styleButtons.find(function (button) { return button.dataset.ldcStyle === requested; });
    if (!matchingButton) return;
    activeShape = 'all';
    activeStyle = requested;
    shapeButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.ldcShape === 'all'));
    });
    styleButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button === matchingButton));
    });
    render();
  }

  function labelForNumber(value) {
    var template = value === 1 ? root.dataset.countOne : root.dataset.countMany;
    return (template || '{{ count }} rings').replace('{{ count }}', value);
  }

  function render() {
    var visible = 0;
    cards.forEach(function (card) {
      var shapeMatch = activeShape === 'all' || card.dataset.shape === activeShape;
      var styleMatch = !activeStyle || (' ' + card.dataset.style + ' ').indexOf(' ' + activeStyle + ' ') !== -1;
      card.hidden = !(shapeMatch && styleMatch);
      if (!card.hidden) visible += 1;
    });
    if (editorial) editorial.hidden = activeShape !== 'all' || activeStyle !== '' || activeSort !== 'manual';
    if (count) count.textContent = labelForNumber(visible);
    if (empty) empty.hidden = visible !== 0;
    if (styleReset) styleReset.hidden = !activeStyle;
    placeEditorial();
    alignIncompleteRows();
  }

  function setShape(value) {
    activeShape = value;
    shapeButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.ldcShape === value));
    });
    render();
  }

  shapeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var requestedShape = button.dataset.ldcShape;
      if (requestedShape !== 'all' && requestedShape === activeShape) requestedShape = 'all';
      activeStyle = '';
      styleButtons.forEach(function (item) {
        item.setAttribute('aria-pressed', 'false');
      });
      setShape(requestedShape);
      if (filterPanel && !filterPanel.hidden && button.closest('[data-ldc-filter-panel]')) {
        filterPanel.hidden = true;
        filterTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  styleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setShape('all');
      activeStyle = activeStyle === button.dataset.ldcStyle ? '' : button.dataset.ldcStyle;
      styleButtons.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item.dataset.ldcStyle === activeStyle));
      });
      render();
    });
  });

  if (styleReset) {
    styleReset.addEventListener('click', function () {
      activeStyle = '';
      setShape('all');
      styleButtons.forEach(function (item) {
        item.setAttribute('aria-pressed', 'false');
      });
      render();
      styleButtons[0] && styleButtons[0].focus();
    });
  }

  function revealGuidanceFromHash() {
    if (!guidance || window.location.hash !== '#find-her-style') return;
    window.setTimeout(function () {
      guidance.scrollIntoView({ behavior: 'smooth', block: 'center' });
      guidance.classList.add('ldc__guidance--attention');
      guidance.focus({ preventScroll: true });
      window.setTimeout(function () { guidance.classList.remove('ldc__guidance--attention'); }, 1800);
    }, 120);
  }

  applyRequestedStyle();
  window.addEventListener('hashchange', revealGuidanceFromHash);
  revealGuidanceFromHash();

  if (filterTrigger && filterPanel) {
    filterTrigger.addEventListener('click', function () {
      var willOpen = filterPanel.hidden;
      filterPanel.hidden = !willOpen;
      filterTrigger.setAttribute('aria-expanded', String(willOpen));
    });
  }

  if (sort) {
    sort.addEventListener('change', function () {
      var mode = sort.value;
      activeSort = mode;
      cards.sort(function (a, b) {
        if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (mode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.manualOrder) - Number(b.dataset.manualOrder);
      });
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
      placeEditorial();
      if (editorial) editorial.hidden = mode !== 'manual' || activeShape !== 'all' || activeStyle !== '';
      alignIncompleteRows();
    });
  }

  placeEditorial();
  alignIncompleteRows();
  window.addEventListener('resize', function () {
    placeEditorial();
    alignIncompleteRows();
  });

})();
